import React, { memo } from 'react';
import { View } from 'react-native';
import { PreviewTabBarItem } from '@redlink/components/molecules';
import { createUseStyle } from '@redlink/assets/styles';

export const PreviewTabBarVertical = memo(
  ({ state, navigation, descriptors }) => {
    const { styles, size, height } = useStyle();
    const focusedOptions = descriptors[state.routes[state.index].key].options;
    if (focusedOptions.tabBarVisible === false) {
      return null;
    }

    return (
      <View
        style={[
          styles.container,
          {
            height: size.previewTabBarVerticalItemHeight * state.routes.length,
            top:
              height / 2 -
              (size.previewTabBarVerticalItemHeight * state.routes.length) / 2,
          },
        ]}
      >
        {state.routes.map((route, index) => {
          return (
            <PreviewTabBarItem
              {...{ route, index, state, descriptors, navigation }}
            />
          );
        })}
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow, height }) => ({
  container: {
    backgroundColor: colors.cardBackground,
    ...shadow.previewTabBar,
    position: 'absolute',
    right: 56,
    width: size.previewTabBarVerticalWidth,
    paddingTop: 26,
    borderRadius: 10,
  },
}));
